import React from 'react';
import ScrollProgress from './components/ScrollProgress';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Skills from './components/Skills';
import TechLogos from './components/TechLogos';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Research from './components/Research';
import './App.css';

function App() {
  return (
    <div className="App">
      <ScrollProgress />
      <Header />
      <Hero />
      <About />
      <Research />
      <Projects />
      <Experience />
      <Skills />
      <TechLogos />
      <Certifications />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
